import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest, serialize } from 'src/utils/request';

export enum ASSET_TYPE {
  WORK_PERMISSION = 'work_permission',
  MATRICULATION_FILE = 'matriculation_file',
  CERTIFICATE_FILE = 'certificate_file',
  USER_LANGUAGE = 'user_language',
  PICTURE = 'picture',
}

const getVerificationRejectReason = async (filters: Record<string, string>) => {
  const queryFilters = serialize(filters, 'filters');

  const { data } = await getRequest(
    API.GET.getVerificationRejectReason(queryFilters.toString()),
  );

  return mapRejectReason(data?.data);
};

export const useGetVerificationRejectReason = (
  filters: Record<string, string>,
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.VERIFICATION_REJECT_REASON, filters],
    queryFn: () => getVerificationRejectReason(filters),
    staleTime: 1000 * 60 * 5,
    ...config,
  });
};

const mapRejectReason = (
  data: {
    attributes: UCM.RejectReasonRawType;
    id: string;
  }[],
): UCM.RejectReasonType[] => {
  if (!data) return [];

  return data.map(({ attributes, id }) => ({
    id,
    value: attributes.code,
    reasonFor: attributes.reason_for,
    label: attributes.title,
  }));
};
